/* global $, whichTransitionEnd, _, ko */

$(function () {
    "use strict";

    var transitionend = whichTransitionEnd();

    // A Timer

    function Timer (callback, delay) {
        var timerId;
        var start;
        var remaining = delay;

        this.pause = function () {
            window.clearTimeout(timerId);
            remaining -= new Date() - start;
        };

        this.resume = function () {
            start = new Date();
            window.clearTimeout(timerId);
            timerId = window.setTimeout(callback, remaining);
        };

        this.resume();
    }

    // A Toast

    function Toast (text, type, link, lifetime) {

        var self = this;

        var generateUUID = function () {
            var d = new Date().getTime();
            return 'toast__xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                var r = (d + Math.random() * 16) % 16 | 0;d = Math.floor(d / 16);
                return (c === 'x' ? r : (r & 0x7 | 0x8)).toString(16);
            });
        };

        var newToast = {
            id: generateUUID(),
            type: _.trim(type),
            text: _.trim(text),
            link: _.trim(link),
            lifetime: Number(lifetime) || 3600
        };

        if (newToast.text.length === 0) {

            var error = {
                message: 'Text of toast cannot be empty',
                extra: {type: type, text: text, link: link, lifetime: lifetime}
            };
        }
        else {
            self.id = newToast.id;
            self.type = newToast.type;
            self.text = newToast.text;
            self.link = newToast.link;
            self.lifetime = newToast.lifetime;
        }
    }

    Toast.prototype.getElement = function () {
        return $('#' + this.id);
    };

    Toast.prototype.show = function (callback) {
        var self = this;
        var $toast = self.getElement();

        _.defer(function () {

            $toast
            .addClass('toast_enter-active')
            .one(transitionend, function (event) {
                event.stopPropagation();
                event.stopImmediatePropagation();

                $toast
                .removeClass('toast_enter')
                .removeClass('toast_enter-active');

                if (_.isFunction(callback)) {
                    callback();
                }
            });

            var timer = self.setDestroyTimeout();

            $toast.on('mouseenter.Toast', function () {
                timer.pause();
            });

            $toast.on('mouseleave.Toast', function () {
                timer.resume();
            });
        });
    };

    Toast.prototype.hide = function (callback) {
        var self = this;
        var $toast = self.getElement();

        if (!self.hiding) {
            self.hiding = true;

            $toast
                .addClass('toast_leave');

            _.defer(function () {
                $toast
                .addClass('toast_leave-active')
                .one(transitionend, function (event) {
                    event.stopPropagation();
                    event.stopImmediatePropagation();

                    $toast
                    .removeClass('toast_leave')
                    .removeClass('toast_leave-active');

                    if (_.isFunction(callback)) {
                        callback();
                    }
                });
            });
        }
    };

    Toast.prototype.setDestroyTimeout = function () {
        var self = this;

        return new Timer(
            function () {
                self.destroy();
            },
            self.lifetime
        );
    };

    Toast.prototype.destroy = function () {
        var self = this;

        self.hide(function () {
            toasts(
                _.without(toasts(), self)
            );
        });
    };

    // Toasts

    var $root   = $('#toasts');
    var toasts = ko.observableArray();

    var pushToast = function (text, type, link, lifetime) {

        if ($root.length > 0) {

            $root.css('max-width', '');

            // Destroy existing
            if (toasts().length > 0) {
                toasts().forEach(function (toast) {
                    toast.destroy();
                });
            }

            var newToast = new Toast(text, type, link, lifetime);

            if (!_.isEmpty(newToast)) {
                toasts.push(newToast);

                _.defer(function () {
                    newToast.show(function () {
                        $root.css(
                            'max-width',
                            newToast.getElement().children().outerWidth() + 5
                            // Several pixels to get sure child won't be overflowwed
                        );
                    });
                });
            }
        }
    };

    function Toasts (toasts, pushToast) {
        this.toasts = toasts;
        this.pushToast = pushToast;
    }

    var ToastsViewModel = new Toasts(toasts, pushToast);

    window.Toasts = ToastsViewModel;

    if ($root.length > 0) {
        ko.applyBindingsIsNotIsBound(ToastsViewModel, $root[0]);
    }
});
